import { FlexColumn, GenericComponent } from '@gorila-shared-ui/components';
import { ParagraphXSmall } from 'baseui/typography';
import { useStyles } from '../../hooks/useStyles';

export function LoginContainer({ children }: GenericComponent) {
  const { css, classes, theme } = useStyles();
  const version = process.env.REACT_APP_VERSION;

  return (
    <FlexColumn
      gap={0}
      classNames={`${classes.fillParent}`}
    >
      <div
        className={css({
          paddingTop: theme.sizing.scale500,
          paddingRight: theme.sizing.scale1600,
          paddingBottom: theme.sizing.scale500,
          paddingLeft: theme.sizing.scale1600,
          backgroundColor: theme.colors.backgroundAlwaysDark,
          height: '60px',
          boxSizing: 'border-box',
          display: 'flex',
          alignItems: 'center',
          gap: theme.sizing.scale400,
        })}
      >
        <img
          src={'/img/login_logo.png'}
          alt="logo"
          className={css({
            height: '100%',
          })}
        />
        <ParagraphXSmall
          margin={0}
          color={theme.colors.contentInversePrimary}
        >
          v{version}
        </ParagraphXSmall>
      </div>
      <FlexColumn
        centered
        classNames={`${classes.fillParent}`}
      >
        {children}
      </FlexColumn>
    </FlexColumn>
  );
}
